export default function navigationToggle() {
    const navigationTogglers = document.querySelectorAll('.navigation__toggler');
    for (let i = 0, len = navigationTogglers.length; i < len; i++) {
        navigationTogglers[i].addEventListener('click', () => {
            document.querySelector('.navigation__collapsible').classList.toggle('navigation__collapsible--collapsed');
            document.querySelector('html').classList.toggle('navigation--collapsed')
        });
    }
}
